__turbopack_context__.v({
  "className": "montserrat_43c6e907-module__IPbB_a__className",
  "variable": "montserrat_43c6e907-module__IPbB_a__variable",
});
